import ParticipantTrackListPage from "components/Admin/Batches/List/Track/BatchParticipantTrack"
import React from "react"

const ListPage = () => {
    return (
        <React.Fragment>
            <ParticipantTrackListPage />
        </React.Fragment>
    )
}
export default ListPage
